// src/components/sidebar/UserSidebar.tsx
import React from 'react';
import ProSidebarBase from './ProSidebarBase'; // default export
import type { NavItem } from './ProSidebarBase';

export type UserSidebarProps = { onLogout: () => void };

const userItems: NavItem[] = [
  { label: '業務報告入力', to: '/report' },
  { label: '業務報告一覧', to: '/reports' },
  { label: '稼働管理', to: '/workingtime' },
];

const UserSidebar = () => {
  return <ProSidebarBase items={userItems} />;
};

export default UserSidebar;
